import { Link as MuiLink, LinkProps as MuiLinkProps } from "@material-ui/core"
import { wrapLink, LinkProps } from "./Link";




export type AnchorProps =  Omit<MuiLinkProps, "component"> & LinkProps;
export const Anchor = wrapLink<AnchorProps>(MuiLink);
